import { Separator } from "@/components/ui/separator";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import Breadcrumber from "../Breadcrumber/Breadcrumber";
import { useBreadcrumb } from "@/contexts/breadcrumbContext";

const AppHeader = () => {
  const { open } = useSidebar();
  const { breadcrumb } = useBreadcrumb();

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className={`-ml-1 ${open ? "ml-2" : ""}`} />
        <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-4" />
        <div>
          <Breadcrumber children={breadcrumb} />
        </div>
        {/* <span className="text-base text-black font-medium">Dashboard</span> */}
      </div>
    </header>
  );
};

export default AppHeader;
